import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as S3 from 'aws-sdk/clients/s3';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UtilsService = /** @class */ (function () {
    function UtilsService(_http) {
        this._http = _http;
        this.location_data = {};
        if (localStorage.getItem('currentUser') == null) {
            window.location.href = environment.SITE_URL + "/logout";
        }
    }
    UtilsService.prototype.getRequest = function (url, mode, extraHeader) {
        if (mode === void 0) { mode = null; }
        if (extraHeader === void 0) { extraHeader = null; }
        var httpOptions = {};
        if (extraHeader == 'content-type-json') {
            httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        }
        else {
            httpOptions = { headers: new HttpHeaders({}) };
        }
        return this._http
            .get(url, httpOptions)
            .pipe(map(function (resp) {
            if (mode == 'getDrafted') {
                localStorage.removeItem('draftedToday');
                localStorage.setItem('draftedToday', JSON.stringify({
                    expires: Date.now() + 60000,
                    value: resp.leagues
                }));
                return resp;
            }
            else {
                return resp;
            }
        }));
    };
    UtilsService.prototype.postRequest = function (url, data, mode, extraHeader) {
        if (mode === void 0) { mode = null; }
        if (extraHeader === void 0) { extraHeader = null; }
        var httpOptions = {};
        if (extraHeader == 'content-type-json') {
            httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        }
        else {
            httpOptions = { headers: new HttpHeaders({}) };
        }
        return this._http
            .post(url, data, httpOptions)
            .pipe(map(function (resp) {
            return resp;
        }), catchError(this.handleErrorPost('rejectRequest')));
    };
    UtilsService.prototype.putRequest = function (url, data, mode, extraHeader) {
        if (mode === void 0) { mode = null; }
        if (extraHeader === void 0) { extraHeader = null; }
        var httpOptions = {};
        if (extraHeader == 'content-type-json') {
            httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        }
        else {
            httpOptions = { headers: new HttpHeaders({}) };
        }
        return this._http
            .put(url, data, httpOptions)
            .pipe(map(function (resp) {
            return resp;
        }), catchError(this.handleErrorPost('rejectRequest')));
    };
    UtilsService.prototype.hasUserLocation = function () {
        var subp = localStorage.getItem('subp');
        if (typeof (subp) === 'undefined' || !subp) {
            return false;
        }
        else {
            var subDecode = (atob(subp)).split('#');
            if (typeof subDecode[5] != 'undefined') {
                var currentTime = Math.floor(new Date().getTime() / 1000);
                var diff = parseInt(subDecode[5]) - currentTime;
                var min = (diff <= 0) ? false : true;
                return min;
            }
            else {
                return false;
            }
        }
    };
    UtilsService.prototype.getUserLocation = function () {
        var locationData = { 'ip': '0', 'state': '0', 'country': '0', 'user_dob': '0000-00-00', 'postcode': '0', 'expiry': '0' };
        var subp = localStorage.getItem('subp');
        if (typeof (subp) !== 'undefined' && subp) {
            var subDecode = (atob(subp)).split('#');
            locationData = {
                'ip': subDecode[0],
                'state': subDecode[1],
                'country': subDecode[2],
                'user_dob': subDecode[3],
                'postcode': subDecode[4],
                'expiry': subDecode[5]
            };
        }
        return locationData;
    };
    UtilsService.prototype.modifyUserLocation = function (data) {
        var subp = localStorage.getItem('subp');
        if (typeof (subp) !== 'undefined' && subp) {
            var subDecode = (atob(subp)).split('#');
            var modifiedSubp = btoa(subDecode[0] + '#' + data['state'] + '#' + data['country'] + '#' + subDecode[3] + '#' + subDecode[4] + '#' + subDecode[5]);
            localStorage.removeItem('subp');
            localStorage.setItem('subp', modifiedSubp);
        }
        return;
    };
    UtilsService.prototype.setUserLocation = function (url, callback) {
        var subp = '';
        var locationData = { 'ip': '0', 'state': '0', 'country': '0', 'user_dob': '0000-00-00', 'postcode': '0', 'expiry': '0' };
        var httpOptions = { headers: new HttpHeaders({}) };
        var request = this._http
            .get(url, httpOptions)
            .pipe(map(function (res) {
            return res;
        }));
        request.subscribe(function (res) {
            if (typeof res !== 'undefined' && res['status'] == 'success') {
                var currentTime = Math.floor(new Date().getTime() / 1000);
                var updatedTIme = currentTime + 2 * 60 * 60;
                locationData = {
                    'ip': res['ip'],
                    'state': res['state'],
                    'country': res['country'],
                    'user_dob': res['user_dob'],
                    'postcode': res['postcode'],
                    'expiry': updatedTIme.toString()
                };
                subp = btoa(res['ip'] + '#' + res['state'] + '#' + res['country'] + '#' + res['user_dob'] + '#' + res['postcode'] + '#' + updatedTIme.toString());
            }
            localStorage.removeItem('subp');
            localStorage.setItem('subp', subp);
            callback(locationData);
        });
    };
    UtilsService.prototype.uploadS3File = function (file, callback) {
        var response = { status: false };
        var randomString = (Math.random() + 1).toString(36).substring(2);
        var ext = (file.name).split('.').pop();
        var fileName = randomString + '.' + ext;
        var bucket = new S3({
            accessKeyId: environment.S3_ACCESS_KEY,
            secretAccessKey: environment.S3_SECRET_KEY,
            region: environment.AWS_REGION
        });
        var params = {
            Bucket: environment.AWS_BUCKET,
            Key: environment.AWS_BUCKET_DIRECTORY + fileName,
            Body: file,
            ACL: 'public-read',
            ContentType: file.type
        };
        bucket.upload(params, function (err, data) {
            if (err) {
                console.log('There was an error uploading your file: ', err);
                callback(response);
            }
            response['status'] = true;
            response['fileName'] = fileName;
            //console.log('Successfully uploaded file.', data);
            callback(response);
        });
    };
    UtilsService.prototype.handleErrorPost = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(result); // log to console instead 
            // TODO: better job of transforming error for user consumption
            console.log(operation + " failed: " + error);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    UtilsService.ngInjectableDef = i0.defineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(i0.inject(i1.HttpClient)); }, token: UtilsService, providedIn: "root" });
    return UtilsService;
}());
export { UtilsService };
